var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitoringPipelineAndScheduler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4277 28.5725V15.1158M15.4277 15.1158L27.4277 3.42969M15.4277 15.1158L3.42773 3.42969",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.428,
    cy: 3.42801,
    r: 1.14286,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.42801,
    cy: 3.42801,
    r: 1.14286,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4291,
    cy: 27.9994,
    r: 1.71429,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.4286,
    cy: 3.42857,
    r: 2.92857,
    stroke: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.42857,
    cy: 3.42857,
    r: 2.92857,
    stroke: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4277,
    cy: 28,
    r: 3.5,
    stroke: "currentColor"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2224,
    cy: 9.93729,
    r: 0.937292,
    fill: "currentColor"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5096,
    cy: 12.1482,
    r: 0.937292,
    fill: "currentColor"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5096,
    cy: 16.9881,
    r: 0.937292,
    fill: "currentColor"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2224,
    cy: 19.0623,
    r: 0.937292,
    fill: "currentColor"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9373,
    cy: 16.9881,
    r: 0.937292,
    fill: "currentColor"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9373,
    cy: 12.1482,
    r: 0.937292,
    fill: "currentColor"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2224,
    cy: 14.4998,
    r: 0.937292,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9277 12.2774L15.1448 9.99609L19.431 12.2774M10.9277 12.2774V17.1167L15.1448 19.2598M10.9277 12.2774L15.1448 14.6279M19.431 12.2774V17.1167L15.1448 19.2598M19.431 12.2774L15.1448 14.6279M15.1448 19.2598V14.6279",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringPipelineAndScheduler);
export default __webpack_public_path__ + "static/media/MonitoringPipelineAndScheduler.d13d38547162c83c5925bdbc6a310843.svg";
export { ForwardRef as ReactComponent };